import React from 'react';
import { Pencil } from 'lucide-react';
import { useEditMode } from '../../contexts/EditModeContext';

/**
 * Nút "sửa" gắn kèm một ứng dụng. Chỉ hiện khi admin đã đăng nhập — khách vào
 * trang thì component này trả về null, không render gì.
 *
 * Bấm vào là mở thẳng form chi tiết (đúng form của trang quản trị).
 */
const EditAppButton = ({ app, variant = 'icon', className = '' }) => {
    const { canEdit, requestEdit } = useEditMode();
    if (!canEdit || !app) return null;

    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        requestEdit(app);
    };

    if (variant === 'pill') {
        return (
            <button
                type="button"
                onClick={handleClick}
                className={`inline-flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium bg-white/70 dark:bg-white/[0.06] backdrop-blur-sm border border-white/60 dark:border-white/10 text-slate-700 dark:text-slate-200 hover:bg-white dark:hover:bg-white/10 transition-colors ${className}`}
            >
                <Pencil className="w-3.5 h-3.5" />
                Sửa nội dung
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-label={`Sửa ${app.title}`}
            title={`Sửa ${app.title}`}
            className={`w-8 h-8 rounded-full flex items-center justify-center bg-slate-900/80 dark:bg-white/20 backdrop-blur-sm text-white hover:bg-primary-600 transition-colors ${className}`}
        >
            <Pencil className="w-3.5 h-3.5" />
        </button>
    );
};

export default EditAppButton;
